import types from '../../mutation-types';

export const mutations = {
  [types.SET_QUEUE_COUNT]: ($state, count) => {
    $state.count = count < 0 ? 0 : count;
  },
};
